const useDotDigital = () => {
  throw new Error("not implemented on web.");
};

export default useDotDigital;
